/*
Dilip 02/02/2023 3031450488 addded download functionality for data manager Execution History
Ashraf 02/03/2022 3031450488 fixed payload issue
Dilip 02/03/2023 3075154998  added start date and end date columns and payload changes
Dilip 02/04/2023 3075154998  added download functionality
Sohel 02/13/2023 3075154998  Start Time and End Time Format Changes
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented

Ravi 02/24/2023 3075154998 implemented previewFile in download Configuration
Ravi 04/01/2023 3075154998 Added loader and download toast message for preview File
Akhila 05/31/2023 3075154998 bug fixed pointer issue execution
Ravi 06/30/2023 3075154998 fixed search button functionality
Sohel 12/12/2023 3075154998 column name code change to import/export name
*/
import React, {createRef, useState, useEffect} from 'react';
import {defaultRows, tablePageRows} from '../../../../../constants/ReusableTablePagination';
import {useUpdateEffect} from 'react-use';
import {Grid, TablePagination} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import {
  fetchDownloadSuccess,
  resetDownloadMsg,
} from '../../../../../redux/reducers/PreviewFileData';
import moment from 'moment';
import PageLoader from '../../../../../components/PageLoader';
import {
  postGenerateUrl,
  ResetDownloadMsg as resetDownloadMessage,
  postExecutionGenerateUrl,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/DataManager';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';
import axios from 'axios';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
const DmExecutionSearchTable = ({ searchData, submit, setSubmit, type }) => {
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();
  const [status, setStatus] = useState(false);
  const { isLoading, downloadSuccessMsg, configurationUrl, dockey } = useSelector(
    ({ dataManagerGroup }) => dataManagerGroup,
  );
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const executionModuleName = type === 'Export' ? "Export Name" : "Import Name"
  useUpdateEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [searchData]);

  useUpdateEffect(() => {
    if (status) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (downloadSuccessMsg) {
      setTimeout(() => {
        dispatch(resetDownloadMessage());
      }, 1500);
    }
  }, [downloadSuccessMsg]);

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  const columns = [
    {
      title: `${executionModuleName}`,
      field: 'dmCode',
      render: (rowData) => (
        <span
          // role="button"
          style={{
            maxWidth: 165,
            textAlign: 'justify',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
          }}
        >
          {rowData?.dmCode}
        </span>
      ),
    },
    // {
    //   title: "Job Description",
    //   field: "jobDescription",
    //   render: (rowData) => (
    //     <span
    //       role="button"
    //       style={{
    //         maxWidth: 165,
    //         textAlign: "justify",
    //         whiteSpace: "normal",
    //         wordWrap: "break-word",
    //       }}
    //     >
    //       {rowData?.jobDescription}
    //     </span>
    //   ),
    // },
    {
      title: 'Type',
      field: 'dmType',
    },
    {
      title: 'Status',
      field: 'status',
      render: (rowData) => (
        <span
          className="history-status"
          style={{ color: rowData.status === 'COMPLETED' ? '#00af00' : '#FA113D' }}
        >
          {rowData?.status ? rowData?.status : rowData?.status ? rowData?.status : ''}
        </span>
      ),
    },

    // {
    //   title: "Executed From",
    //   field: "startTime",
    //   render: (rowData) => {
    //     return rowData?.startTime
    //       ? moment(rowData?.startTime).tz("America/New_York").utc().format("MM/DD/YYYY")
    //       : "";
    //   },
    // },
    // {
    //   title: "Executed To",
    //   field: "endTime",
    //   render: (rowData) => {
    //     return rowData?.endTime
    //       ? moment(rowData?.endTime).tz("America/New_York").utc().format("MM/DD/YYYY")
    //       : "";
    //   },
    // },
    {
      title: 'Executed By',
      field: 'executedBy',
      render: (rowData) => {
        return rowData?.executedBy;
      },
    },
    {
      title: 'Start Date & Time',
      field: 'startDttm',
      render: (rowData) => (
        <>
          {rowData?.startDttm &&
            moment(rowData?.startDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm A')}
        </>
      ),
    },
    {
      title: 'End Date & Time',
      field: 'endDttm',
      render: (rowData) => (
        <>
          {rowData?.endDttm &&
            moment(rowData?.endDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm A')}
        </>
      ),
    },
    // {
    //   title: "Created Date",
    //   field: "createdDate",
    //   render: (rowData) => {
    //     return rowData?.createdDate ? moment(rowData?.createdDate).format("MM/DD/YYYY") : "";
    //   },
    // },
    // {
    //   title: "Status",
    //   field: "isDraft",
    //   render: (rowData) =>
    //     rowData?.isDraft === "Y" ? (
    //       <div class="completed-status status">
    //         <span style={{ color: "#ff8b00", fontWeight: "bold" }}>Draft</span>
    //       </div>
    //     ) : (
    //       <div class="completed-status status" style={{ fontWeight: "bold", color: "#00af00" }}>
    //         <span>Completed</span>
    //       </div>
    //     ),
    // },
  ];

  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={type === 'Export Manager' ? 'Export' : 'Import Manager'}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon new-standard-textfields accountsummry-tablescroll">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-manager/execution/searchall/dmexecution`;
                const bodyObj = {
                  dmCode: searchData?.dataManagerCode ? searchData?.dataManagerCode : '',
                  dmType: searchData?.dataManagerType?.value
                    ? searchData?.dataManagerType?.value
                    : '',
                  executedBy: searchData?.executedBy?.userLoginName
                    ? searchData?.executedBy?.userLoginName
                    : '',
                  startDttm: searchData?.executedFrom
                    ? moment(searchData?.executedFrom).format('YYYY-MM-DD')
                    : '',
                  endDttm: searchData?.executedTo
                    ? moment(searchData?.executedTo).format('YYYY-MM-DD')
                    : '',
                  status: searchData?.status ? searchData?.status : '',
                  tabType: type === 'Export' ? 'Export' : 'Import',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: submit
                    ? 1
                    : arrayLast && query.page >= 1
                      ? query.page
                      : arrayLast
                        ? (query.page <= 1 && query.page + 1) || query.page - 1
                        : query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setSubmit(false);
                        setArrayLast(data.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            actions={[
              (rowData) => {
                if (rowData?.documentKey && type === 'Export') {
                  return {
                    icon: () => <GetAppOutlinedIcon />,
                    tooltip: 'Download',
                    // disabled: rowData.status === "IN_PROGRESS",
                    onClick: (event, rowData) => {
                      dispatch(
                        postGenerateUrl(
                          {
                            dockey: rowData?.documentKey,
                          },
                          type,
                        ),
                      );
                    },
                  };
                }
              },
              (rowData) => {
                if (rowData?.logDocumentKey) {
                  return {
                    icon: () => <ArchiveOutlinedIcon />,
                    tooltip: 'Download',
                    // disabled: rowData.status === "IN_PROGRESS",
                    onClick: (event, rowData) => {
                      dispatch(
                        postExecutionGenerateUrl(
                          {
                            dockey: rowData?.logDocumentKey,
                          },
                          type,
                        ),
                      );
                      dispatch(
                        fetchDownloadSuccess({
                          response: `${
                            type === 'Export' ? 'Export' : 'Import'
                          } Execution History Downloaded Successfully`,
                        }),
                      );
                    },
                  };
                }
              },
            ]}
            options={{
              search: false,
              pageSize: rows,
              toolbar: false,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: { 'aria-label': 'Rows per screen' },
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
        {(isLoading || isLoadingPrint) && <PageLoader />}
        {/* {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />} */}
        {/* {downloadSuccessMsg && <SuccessSnackbar successMsg={downloadSuccessMsg} />} */}
      </Grid>
    </>
  );
};

export default DmExecutionSearchTable;
